<template>
    <div>
        <div class="title" :style="getTitleStyle()">
            {{ myObj.bottom_list_tagsandphotos_params.title }}
        </div>
        <div class="list-box" :style="getListBoxStyle()">
            <div v-for="(item, index) in 20" :key="index" class="item">
                <div style="font-size: small;margin-bottom:5px">标签{{ index }}</div>
                <div class="cell-box">
                    <div v-for="(childItem, childIndex) in 5" class="cell" :style="getCellStyle()">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomListTagsAndPhotosView",
    props: ['obj'],
    data() {
        return {
            myObj: this.obj
        }
    },
    methods: {
        getTitleStyle() {
            return `margin-left: ${this.obj.bottom_list_tagsandphotos_params.margin}px`
        },
        getListBoxStyle() {
            return `padding-left: ${this.obj.bottom_list_tagsandphotos_params.margin}px;` +
                `gap: ${this.obj.bottom_list_tagsandphotos_params.between_space}px;`
        },
        getCellBoxStyle() {
            return ''
        },
        getCellStyle() {
            const between_space = this.obj.bottom_list_tagsandphotos_params.between_space
            const corner_radius = this.obj.bottom_list_tagsandphotos_params.corner_radius
            const itemWidth = this.obj.bottom_list_tagsandphotos_params.item_width
            const itemHeight = this.obj.bottom_list_tagsandphotos_params.item_height
            const style = `width:${itemWidth}px;
                        height:${itemHeight}px;
                        margin-right:${between_space}px;
                        border-radius:${corner_radius}px; `
            return style
        },
    }
}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    line-height: 40px;
}

.list-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;

    .item {
        width: 100%;
    }
}

.cell-box {
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;

    .cell {
        display: inline-block;
        background-color: lightsteelblue;
        text-align: center;
        font-size: small;
        flex-shrink: 0;
    }
}
</style>